import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectureItems } from "../../../../services/dashboard/apiLecture";
export function useLectureItems({
  perPage,
  page,
  courseId,
  lectureId,
  includeFields,
} = {}) {
  const queryClient = useQueryClient();

  const {
    data: lectureItems,
    isPending,
    isSuccess,
  } = useQuery({
    queryKey: [
      "lectureItemsDashboard",
      includeFields,
      courseId,
      lectureId,
      perPage,
      page,
    ],
    queryFn: () =>
      getLectureItems({
        courseId,
        lectureId,
        includeFields,
        perPage,
        page,
      }),
  });

  const totalPages = Math.ceil(
    lectureItems?.meta?.total / lectureItems?.meta?.per_page
  );

  // PRE - FETCHING;
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "lectureItemsDashboard",
        includeFields,
        perPage,
        page,
        courseId,
        lectureId,
      ],
      queryFn: () =>
        getLectureItems({
          courseId,
          lectureId,
          includeFields,
          perPage,
          page: page++,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "lectureItemsDashboard",
        includeFields,
        perPage,
        page,
        courseId,
        lectureId,
      ],
      queryFn: () =>
        getLectureItems({
          courseId,
          lectureId,
          includeFields,
          perPage,
          page: page--,
        }),
    });
  }

  return { isPending, lectureItems };
}
